<template>
  <div id="app">
    <!-- Loader starts-->
    <div class="loader-wrapper" :class="{ 'loderhide': !show }">
      <div class="loader-index">
        <span></span>
      </div>
    </div>
    <!-- Loader ends-->

    <!--<Main/>-->
    <router-view></router-view>

    <EmpDownloadHudHost />
    <FormSubmitPopupMessage />
  </div>
</template>

<script>
import { webResourcesService } from "../src/_services"
import * as constantsConfig from "../src/constants/config";
import FormSubmitPopupMessage from "./components/popup/FormSubmitPopupMessage.vue";


//load Kendo Language
import { enGrid, zhHansGrid, zhHantGrid} from './data/kendoLocalization'
import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-vue-intl';
import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import currencyData from "cldr-core/supplemental/currencyData.json";
import weekData from "cldr-core/supplemental/weekData.json";
import Hans_numbers from "cldr-numbers-full/main/zh-Hans/numbers.json";
import Hans_caGregorian from "cldr-dates-full/main/zh-Hans/ca-gregorian.json";
import Hans_dateFields from "cldr-dates-full/main/zh-Hans/dateFields.json";
import Hans_timeZoneNames from "cldr-dates-full/main/zh-Hans/timeZoneNames.json";
import Hant_numbers from "cldr-numbers-full/main/zh-Hant/numbers.json";
import Hant_caGregorian from "cldr-dates-full/main/zh-Hant/ca-gregorian.json";
import Hant_dateFields from "cldr-dates-full/main/zh-Hant/dateFields.json";
import Hant_timeZoneNames from "cldr-dates-full/main/zh-Hant/timeZoneNames.json";

load(
  likelySubtags,
  currencyData,
  weekData,
  Hans_numbers,
  Hans_caGregorian,
  Hans_dateFields,
  Hans_timeZoneNames,
  Hant_numbers,
  Hant_caGregorian,
  Hant_dateFields,
  Hant_timeZoneNames,
);
loadMessages(enGrid, 'en-US');
loadMessages(zhHansGrid, 'zh-Hans');
loadMessages(zhHantGrid, "zh-Hant");

export default {
  name: 'app',
  components: {
    FormSubmitPopupMessage,
  },
  data() {
    return {
      show: true,
      localeOptions: constantsConfig.localeOptions,
      langText: localStorage.getItem('currentLanguageName') || '简体中文',
      versionCheckTimer: null,
      isVersionPrompting: false,
      ignoredVersionKey: "empbe_ignored_version",
      currentVersionKey: "empbe_current_version",
    };
  },
  created() {

  },
  mounted() {
    this.timeOut();
    var currentLanguageName = this.localeOptions.filter(x => x.name === (this.langText))[0];
    //this.GetWebResources(currentLanguageName);

    // Periodically check /public/version.json, prompt reload if changed
    this.startVersionCheck();
  },
  beforeDestroy() {
    this.stopVersionCheck();
  },
  methods: {
    timeOut() {
      var self = this;
      setTimeout(function () {
        self.show = false;
      }, 500);
    },
    GetWebResources(currentLanguageName) {
      var that = this;
      var isrefresh = this.$route.query.isrefresh === 'true' ? true : false;
      webResourcesService.GetWebResourcesValue_byPrefix(currentLanguageName.langid, isrefresh)
        .then(
          data => {
            that.$i18n.mergeLocaleMessage(currentLanguageName.id, JSON.parse(data))
            //console.log(JSON.parse(data));debugger; //[20231114][JWS] Use this in debug mode to get GetWebResources object to copy to file
          }
        )
    },

    stopVersionCheck() {
      if (this.versionCheckTimer) {
        clearInterval(this.versionCheckTimer);
        this.versionCheckTimer = null;
      }
    },

    async getRemoteVersion(){

      const getUrl = () => {
        // Ensure no cache (CDN/proxy/browser)
        const base = (process.env && process.env.BASE_URL) ? process.env.BASE_URL : "/";
        const u = `${base.replace(/\/?$/, "/")}version.json`;
        const sep = u.includes("?") ? "&" : "?";
        return `${u}${sep}_ts=${Date.now()}`;
      };

      let remote;
      try {
        const res = await fetch(getUrl(), {
          cache: "no-store",
          headers: {
            "Cache-Control": "no-cache, no-store, must-revalidate",
            "Pragma": "no-cache",
            "Expires": "0",
          },
        });
        if (!res.ok) return;
        remote = await res.json();
      } catch (e) {
        // Network errors should not block the app
        return;
      }

      const remoteVersion = (remote && remote.version != null) ? String(remote.version) : "";
    },

    async setVersion(version){
      const currentVersionKey = this.currentVersionKey;
      var remoteVersion = version;
      if (!version)
      {
        remoteVersion = await this.getRemoteVersion();
      }
      if (!remoteVersion) return;
      localStorage.setItem(currentVersionKey, remoteVersion);
    },

    startVersionCheck() {
      // Avoid duplicate timers in hot-reload or keep-alive scenarios
      this.stopVersionCheck();

      // First check quickly, then poll
      this.checkVersionAndPromptIfNeeded();

      const CHECK_INTERVAL_MS = 10 * 10000; // 10 minutes
      this.versionCheckTimer = setInterval(() => {
        this.checkVersionAndPromptIfNeeded();
      }, CHECK_INTERVAL_MS);
    },

    async checkVersionAndPromptIfNeeded() {
      const currentVersionKey = this.currentVersionKey;

      if (this.isVersionPrompting) return;

      const remoteVersion = await this.getRemoteVersion();
      if (!remoteVersion) return;

      const localVersion = localStorage.getItem(currentVersionKey);
      if (!localVersion) {
        // First run: record baseline
        this.setVersion(remoteVersion);
        return;
      }

      if (remoteVersion === localVersion) return;

      const ignoredVersion = sessionStorage.getItem(ignoredVersionKey);
      if (ignoredVersion === remoteVersion) return;

      this.isVersionPrompting = true;
      this.stopVersionCheck();

      const title = (this.$t && typeof this.$t === "function" && this.$t("lbl_EMPBE_SystemUpdated"))
        ? this.$t("lbl_EMPBE_SystemUpdated") || "System updated"
        : "System updated";
      const msg = (this.$t && typeof this.$t === "function" && this.$t("lbl_EMPBE_SystemUpdated_ReloadPrompt"))
        ? this.$t("lbl_EMPBE_SystemUpdated_ReloadPrompt") || "A new version is available. Reload now?"
        : "A new version is available. Reload now?";
      const confirmText = (this.$t && typeof this.$t === "function" && this.$t("lbl_EMPBE_Refresh"))
        ? this.$t("lbl_EMPBE_Refresh") || "Reload"
        : "Reload";
      const cancelText = (this.$t && typeof this.$t === "function" && this.$t("lbl_EMPBE_Later"))
        ? this.$t("lbl_EMPBE_Later") || "Later"
        : "Later";

      try {
        const result = await this.$swal({
          toast: true,
          position: "bottom-end",
          title,
          html: msg,
          icon: "info",
          showCancelButton: true,
          confirmButtonText: confirmText,
          cancelButtonText: cancelText,
          showCloseButton: true,
          timer: 0,
          backdrop: false,
          allowOutsideClick: true,
          allowEscapeKey: true,
        });

        if (result && result.isConfirmed) {
          // Persist new baseline (useful if reload is blocked or user uses bfcache)
          localStorage.setItem(currentVersionKey, remoteVersion);
          window.location.reload();
          return;
        }

        // User chose "Later": don't reprompt for the same version in this tab
        sessionStorage.setItem(ignoredVersionKey, remoteVersion);
      } finally {
        this.isVersionPrompting = false;
        this.startVersionCheck();
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.loader-wrapper.loderhide {
  display: none;
}
</style>
<style>
h6 {
  font-weight: bold !important;
}
</style>